import { Injectable } from '@angular/core';
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {
  CorreoPlantillaDto,
  ICorreoPlantillaEditDto,
  ICorreoPlantillaRespuestaCrearDto
} from "../../shared/interfaces/database/configuracion";
import {Observable} from "rxjs";
import {PaginationParams,Page, QueryParam, Utils} from "lib-base";
import {TableLazyLoadEvent} from "primeng/table";

@Injectable({
  providedIn: 'root'
})
export class CorreoTemplateService {
  private readonly baseUrl = `${environment.apiUrl}/api/correos-plantillas`;

  constructor(private http: HttpClient) { }


  createPlantilla(data: CorreoPlantillaDto): Observable<ICorreoPlantillaRespuestaCrearDto>{
    return this.http.post<ICorreoPlantillaRespuestaCrearDto>(`${this.baseUrl}/crear`, data);
  }

  getAllTemplates(event: TableLazyLoadEvent): Observable<Page<ICorreoPlantillaEditDto>> {
    let params = Utils.getLazyLoadParams(event ?? {});
    return this.http.get<Page<ICorreoPlantillaEditDto>>(`${this.baseUrl}/get-all`,
      {params});
  }

  getCorreoPlantillaDetail(): Observable<ICorreoPlantillaEditDto[]> {
    return this.http.get<ICorreoPlantillaEditDto[]>(`${this.baseUrl}/correo-plantilla-detail`);
  }

  getListTemplates():Observable<CorreoPlantillaDto[]> {
    return this.http.get<CorreoPlantillaDto[]>(`${this.baseUrl}/get-list`)
  }

  desactivar(id:number):Observable<boolean>{
    return this.http.put<boolean>(`${this.baseUrl}/desactivar/${id}`, {});
  }

  actualizarPlantilla(id: number, data: CorreoPlantillaDto): Observable<ICorreoPlantillaRespuestaCrearDto> {
    return this.http.put<ICorreoPlantillaRespuestaCrearDto>(`${this.baseUrl}/actualizar/${id}`, data);
  }

}
